module.exports = __webpack_public_path__ + "img/31.1c36c734.jpg";